import { render, staticRenderFns } from "./authProject.vue?vue&type=template&id=51385be6&scoped=true"
import script from "./authProject.vue?vue&type=script&lang=js"
export * from "./authProject.vue?vue&type=script&lang=js"
import style0 from "./authProject.vue?vue&type=style&index=0&id=51385be6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51385be6",
  null
  
)

export default component.exports